import axios from 'axios'
import {UserModel} from '../models/UserModel'

const FLEKSUP_API = process.env.REACT_APP_FLEKSUP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${FLEKSUP_API}/verify_token`
export const LOGIN_URL = `${FLEKSUP_API}/api/account/login`
export const LOGIN_URL_With_RowId = `${FLEKSUP_API}/api/account/login-by-rowId`
export const REQUEST_PASSWORD_URL = `${FLEKSUP_API}/register`
export const REGISTER_URL = `${FLEKSUP_API}/api/account/register`

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post(LOGIN_URL, {
    email,
    password,
  })
}
export function loginbyRowId(rowId: string) {
  return axios.post(LOGIN_URL_With_RowId, {
    rowId
  })
}

// Server should return AuthModel
export function register(user: any) {
  return axios.post(REGISTER_URL, {
    company_Name: user.company_Name,
    email: user.email,
    password: user.password,
    first_Name: user.first_Name,
    last_Name: user.last_Name,
    phone: user.phone,
    erpType: user.erpType,
    ecommerceType: user.ecommerceType
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}
